module.exports = __webpack_public_path__ + "static/media/undraw_add_file2_gvbb.84371f25.svg";